/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { ChargerApi } from "client";
import { useApiWithTimeout } from "./ApiWrapperWithTimeout";
import { useCallApi } from "./CallApiHook";
import { useUserContext } from "context/UserContext";
import { Const } from "const";

export interface ChargerItem {
  id: string;
  settingNodeId: number;
  nameId: string;
}
export const useChargers = () => {
  const [api, canceler] = useApiWithTimeout(
    ChargerApi,
    Const.operationTimeout.getChargers
  );
  const { jobsite } = useUserContext();
  return useCallApi<ChargerItem[]>(
    async () => {
      if (jobsite?.jobSiteId === undefined) {
        return [];
      }
      // Retrieve materials
      const response = await api.getChagerInfo({
        jobsiteId: jobsite.jobSiteId,
      });
      return (
        response.chargerInfos?.map((charger) => {
          return {
            id: charger.assetId,
            settingNodeId: charger.settingNodeId,
            nameId: charger.nameId,
          } as ChargerItem;
        }) ?? []
      );
    },
    canceler,
    [jobsite?.jobSiteId, api, canceler]
  );
};
